"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var schema = (0, _yup.object)().shape({
  email: (0, _yup.string)().min(1).max(64).email().required(),
  checkboxDataPrivacy: (0, _yup["boolean"])().oneOf([true]).required()
});
var schemaEmail = (0, _yup.object)().shape({
  email: (0, _yup.string)().email()
});

var AccountForm = function AccountForm(_ref) {
  var onNextClick = _ref.onNextClick,
      infos = _ref.infos;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFilled = _useState2[0],
      setIsFilled = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = (0, _react.useState)({
    email: '',
    checkboxDataPrivacy: false,
    defaultLanguage: 'de-DE'
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      inputs = _useState6[0],
      setInputs = _useState6[1];

  var firstUpdate = (0, _react.useRef)(true);

  if (firstUpdate.current) {
    setInputs({
      defaultLanguage: infos.defaultLanguage
    });
    firstUpdate.current = false;
  }

  (0, _react.useEffect)(function () {
    try {
      if (schemaEmail.validateSync(inputs)) {
        setIsFilled(true);
      }
    } catch (e) {
      setIsFilled(false);
    }

    try {
      if (schema.validateSync(inputs)) {
        setIsValid(true);
      }
    } catch (e) {
      setIsValid(false);
    }
  }, [inputs, isValid]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex bg-cyan-500 justify-around items-center h-full w-full text-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sm:w-1/2 lg:w-1/2 xl:w-2/5 2xl:w-1/3 bg-white pt- 5 pl-12 pr-12 pb-5 flex flex-col text-base space-around rounded"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    height: "90",
    width: "280",
    className: "self-center mb-10"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.header.left.start"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold mb-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.header.left.middle",
    tagName: "span"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.text.nic"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "my-4"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: inputs.email,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        email: e
      }));
    },
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.account.mail"
    }),
    tagName: "span"
  }), !isFilled && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.warning"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-red-600 text-sm"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.account.checkbox.gtc.first"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm mt-4"
      }, value);
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.account.checkbox.gtc"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.fourkites.ai/legal/saas-agreement-emea",
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        className: "text-sm text-cyan-500 underline mx-1"
      }, value);
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.account.checkbox.gtc.second"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm"
      }, value);
    })),
    checked: inputs.checkboxDataPrivacy,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        checkboxDataPrivacy: e
      }));
    },
    className: "flex-shrink-0"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm mt-1 ml-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.checkbox.privacy.start"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", null, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.checkbox.privacyNotice"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: "https://www.fourkites.ai/legal/nic-place-privacy-notice",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      className: "text-cyan-500 underline mx-1"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.checkbox.gtc.third"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", null, value);
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    disabled: !isValid,
    onClick: (0, _react.useCallback)(function () {
      onNextClick({
        email: inputs.email,
        checkboxDataPrivacy: inputs.checkboxDataPrivacy
      });
    }, [inputs, onNextClick]),
    className: " self-center mt-4",
    primary: true,
    raised: true
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.button",
    tagName: "span"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:block w-2/5 text-base text-white font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.header.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h1", {
      className: "text-4xl uppercase mb-8"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.account.text.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h1", {
      className: "text-xl mb-8"
    }, value);
  })));
};

var noop = function noop() {};

AccountForm.propTypes = {
  onNextClick: _propTypes["default"].func,
  infos: _propTypes["default"].shape({
    defaultLanguage: _propTypes["default"].string
  })
};
AccountForm.defaultProps = {
  onNextClick: noop,
  infos: {
    defaultLanguage: 'de-DE'
  }
};
var _default = AccountForm;
exports["default"] = _default;